import { PageHeaderMenuItem } from '@/components/PageHeader/PageHeader.model';
import { fetchAccessibleProductLink } from '@/utils/products/global-element-product-access-check';

/**
 * Processes a fourth-level menu item to determine its product link and availability.
 *
 * @param fourthLevelMenuItem - The menu item to process.
 * @param isElavon - Boolean indicating if the site brand is Elavon.
 * @param allProductVersionsInfo - Information about all product versions.
 * @param countryCode - The country code for localization.
 * @returns An object containing the product link and availability status.
 */
export function processFourthLevelMenuItem(
  fourthLevelMenuItem: PageHeaderMenuItem,
  isElavon: boolean,
  allProductVersionsInfo: Record<string, any>,
  countryCode: string
): { subChildProductLink: string | undefined; isProductSuiteProductAvailable: number } {
  const SUB_CHILD_PATH_DEPTH = 4;
  const subChild = fourthLevelMenuItem?.url?.split('/');
  const subChildPathDepth = subChild?.length || 0;
  const subChildVersion = subChild ? subChild[subChild.length - 1] : '';
  const subChildProductSlug = subChild ? subChild[subChild.length - 2] : '';
  let subChildProductLink = fourthLevelMenuItem?.url;

  let isProductSuiteProductAvailable = 0;

  if (!isElavon && fourthLevelMenuItem?.value && subChildPathDepth === SUB_CHILD_PATH_DEPTH) {
    subChildProductLink = fetchAccessibleProductLink(
      subChildVersion,
      subChildProductSlug,
      allProductVersionsInfo,
      countryCode
    );
    if (subChildProductLink) {
      isProductSuiteProductAvailable += 1;
    }
  }

  return { subChildProductLink, isProductSuiteProductAvailable };
}